import { ReportType } from '@common/types';

export const reportTypeLabelMapper = (reportType: ReportType) => {
  switch (reportType) {
    case ReportType.PATIENTS:
      return 'Patients';
    case ReportType.RECORDS:
      return 'Records';
    case ReportType.TASKS:
      return 'Tasks';
    case ReportType.USERS:
      return 'Users';
    default:
      return 'Unknown report type';
  }
};
